import type { LanguageType } from '../services/i18n';

const NUMBER_LOCALE_BY_LANGUAGE: Record<LanguageType, string> = {
  zh: 'zh-CN',
  'zh-TW': 'zh-TW',
  en: 'en-US',
};

/**
 * Formats large user-visible counters with the active language's compact unit.
 * Examples: 20K (en), 2万 (zh), 2萬 (zh-TW).
 */
export function formatLocalizedCompactNumber(
  value: number,
  language: LanguageType,
): string {
  const count = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat(NUMBER_LOCALE_BY_LANGUAGE[language], {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(count);
}
